import * as React from 'react';
import { Component } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { Redirect } from 'react-router';
import SessionStore from 'stores/domain/session';
import { observer, inject } from 'mobx-react';

interface Props extends RouteProps {
    sessionStore?: SessionStore;
}

@inject('sessionStore')
@observer
export default class ProtectedRoute extends Component<Props, {}> {
    render() {
        let { isAuthenticated } = this.props.sessionStore!;
        
        return (
            <div>
                {isAuthenticated ? (
                    <Route {...this.props}>
                        {this.props.children}
                    </Route>
                ) : (
                    <Redirect to={{ pathname: '/login', state: {} }}/>
                )}
            </div>
        );
    }
}